
import { useEffect , useState } from "react";
import React from "react";
import style from './index.css'
import Card from './Card.js'
import Pokeinfo from './PokemonInfo.js'
import axios  from "axios"

export default  function App(){
    const[pokeData , setPokeData]=useState([]);
    const [loading , setLoading] = useState(true);
    const[url , setUrl]=useState("https://pokeapi.co/api/v2/pokemon");
    const[nextUrl, setNextUrl] =useState();
    const[prevUrl , setPrevUrl] = useState();
    const [pokeDex , setPokeDex] = useState();
console.log(pokeDex)
    const pokemonFun=async()=>{
        setLoading(true)
        const res = await axios.get(url);
        // console.log(res)
        setNextUrl(res.data.next);
        setPrevUrl(res.data.previous);
        getPokemon(res.data.results)
        setLoading(false)
        console.log(pokeData)
    }

     const getPokemon=async(res) =>{
        res.map(async(item) =>{
            // console.log(item.url)
            const result = await axios.get(item.url)
            // console.log(result)
            setPokeData(state=> {
                state=[...state , result.data]
                state.sort((a,b) => a.id > b.id? 1 : -1)
                
                return state
            })
        })
    }


    useEffect(() => {
        pokemonFun()

    },[url])
    return(
        <div className='container'>
            <div className='left-content'>
                <Card pokemon={pokeData} loading={loading} infoPokemon={poke=>setPokeDex(poke)}   />
                <div className="btn-group">
                    <button onClick={() =>{
                        setUrl(prevUrl)
                    }}>
                        Previous
                        </button>

                    <button onClick={() =>{
                        setUrl(nextUrl)
                    }}>Next
                    </button>
                </div>

            </div>
            <div className='right-content'>
                <Pokeinfo data={pokeDex} />
                
            </div>

        </div>
        
    )
}
